import { createFileRoute } from "@tanstack/react-router";
import MultilingualNotaryLanding from "@/components/MultilingualNotaryLanding";
import { getNotaryLocale, NOTARY_HREFLANG_ALTS } from "@/data/notary-i18n";
import { multiHreflangLinks, SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";
import { notaryHowToSchema, notarySpeakableSchema } from "@/lib/notary-schema";

const L = getNotaryLocale("id")!;

export const Route = createFileRoute("/id/notary")({
  head: () => ({
    meta: [
      { title: ctaTitle(L.title, "/id/notary", "th")},
      { name: "description", content: ctaDesc(L.description, "/id/notary", "th")},
      { property: "og:title", content: ctaTitle(L.title, "/id/notary", "th")},
      { property: "og:description", content: ctaDesc(L.description, "/id/notary", "th")},
      { property: "og:url", content: `${SEO_SITE}${L.path}` },
      { property: "og:locale", content: "id_ID" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${L.path}` },
      ...multiHreflangLinks(NOTARY_HREFLANG_ALTS, "/notary"),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Notary Public di Bangkok", url: `${SEO_SITE}${L.path}`,
        areaServed: "TH", inLanguage: "id", priceRange: "฿500–฿5,000",
        serviceType: "Notarial Services Attorney",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "id",
        mainEntity: L.faqs.map((f) => ({
          "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }) },
      notaryHowToSchema({ url: `${SEO_SITE}${L.path}`, name: L.stepsH2, inLanguage: "id", steps: L.steps }),
      notarySpeakableSchema(`${SEO_SITE}${L.path}`),
    ],
  }),
  component: () => <MultilingualNotaryLanding l={L} />,
});
